// extracted by mini-css-extract-plugin
export default {"errorScreen":"errorScreen_errorScreen__CuAQ2"};